<template>
    <el-dialog :title="$t('factories.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" 
            :inline="false"  
            label-width="100%"  
            :model='selectedObject'  
            ref='my-form'
            :rules='rules'
            @submit.prevent="save" v-loading="loading">
            
             <el-row :gutter="12">

                 <el-col :span="12">
                    <el-form-item :label="$t('factories.email')" prop="Email" :required="true">
                        <el-input v-model="selectedObject.Email"  autofocus></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('factories.address')" prop="Address" :required="true">
                        <el-input v-model="selectedObject.Address" ></el-input>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('factories.country')" prop="Country" :required="true">
                        <el-input v-model="selectedObject.Country"  autofocus></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('factories.code')" prop="ShortCode" :required="true">
                        <el-input v-model="selectedObject.ShortCode" ></el-input>
                    </el-form-item>
                 </el-col>
             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "factory-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      groups: [],
      factories: [],
      rules: {
          Email: [ { required: true, message: this.$t('form_errors.email_required'), trigger: 'blur' } ],
          Address: [ { required: true, message: this.$t('form_errors.address_required'), trigger: 'blur' } ],
          Country: [ { required: true, message: this.$t('form_errors.country_required'), trigger: 'blur' } ],
          ShortCode: [ { required: true, message: this.$t('form_errors.short_code_required'), trigger: 'blur' } ],
      }
    }
  },
  methods: {
     show_me: function( selectedObject ) {
         this.mode = "edit";
        if( selectedObject == null ) {
            selectedObject  = {};
            this.mode       = "add";
        }
        this.showPopup       = true;
        this.selectedObject  = JSON.parse( JSON.stringify( selectedObject ) );
    },
    load_info: function(){
        //aici incarcam dropdownuri sau alte elemente, la nevoie
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('factories/save',  { mode: this.mode, object: this.selectedObject } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
        
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>
